export class PageDTO<T> {
    pageItems: Array<T> = [];
    itemsCount: number = 0;
  }